// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvInstructions-Grid_cls1__ZSYm+","cls2":"GroupCsvInstructions-Grid_cls2__LSmuO GroupCsvInstructions-Grid_cls1__ZSYm+"};